export default __webpack_public_path__ + "static/media/nimbus-bg.215dcdb2.png";